// BrowseTab.js
import { connect } from 'react-redux';
import { replace } from 'redux-first-history';

import { BROWSE_TABS } from '../RemoteConfigKeys.js';
import BrowseTab from '../component/BrowseTab.jsx';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import { SEARCH_MODAL_ID } from '../resource/searchConstants.js';

const mapStateToProps = state => {
  const isSearchModalOpened = ['opening', 'display'].includes(
    getModalData(state, SEARCH_MODAL_ID, 'status')
  );
  const shouldRenderSearchBar = !isSearchModalOpened;
  return {
    meId: getMeData(state, 'id'),
    tabs: getRemoteConfigData(state, BROWSE_TABS),
    shouldRenderSearchBar,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: ({ pathname }) => dispatch(replace(pathname)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowseTab);
